const selectLocale = (state) => state.ui.i18n.locale;

export default selectLocale;
